export const Home ="/"
export const WhoWeAre ="/who-we-are"
export const Getinvolve ="/get-involved"
export const Polices ="/polices"
export const Media ="/media"
export const Events = "/events"